module.exports = __webpack_public_path__ + "fonts/default_logo.1b56d96222c5cbbbba9d197ab45a3a2f.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/login/default_logo.png
// module id = 115
// module chunks = 9